<template>
  <div
    id="js_header_city"
    class="header-city"
    :style="{top:top,right:right}"
  >
    <div
      class="header-city__hd"
      @click.stop
    >
      <el-row>
        <el-col
          v-for="tab of tabs"
          :key="tab"
          :span="3"
        >
          <span
            class="header-city__tab"
            :class="curTab === tab ? 'header-city__tab_active' : ''"
            @click.stop="curTab = tab"
          >{{ tab }}</span>
        </el-col>
      </el-row>
      <!-- 英文要改 -->
      <a
        v-if="CookiesOne==='en-US'"
        href="javascript:;"
        class="header-city__close"
        title="关闭弹层"
        @click.stop="$emit('onHideCity')"
      >
        <img
          src="./imgs/close.png"
          alt="关闭弹层"
        />
      </a>
      <!-- 中文 -->
      <a
        v-if="CookiesOne!=='en-US'"
        href="javascript:;"
        class="header-city__close"
        title="关闭弹层"
        @click.stop="$emit('onHideCity')"
      >
        <img
          src="./imgs/close.png"
          alt="关闭弹层"
        />
      </a>
    </div>
    <div class="header-city__bd">
      <dl
        v-for="cities of getSelectedCityData"
        :key="cities[0]"
        class="header-city__item"
      >
        <dt
          v-if="cities[0] !== TLang('热门', 'my')"
          class="header-city__label"
        >
          {{ cities[0] }}
        </dt>
        <dd class="header-city__conts">
          <el-row>
            <el-col
              v-for="city of cities[1]"
              :key="city.cityId"
              :span="6"
            >
              <a
                href="javascript:;"
                :title="CookiesOne ==='en-US' ? city.pinyin : city.name"
                :class="city.cityId === cityId ? 'header-city__conts_active' : ''"
                @click.stop="changeCity(city.cityId)"
              >{{ CookiesOne ==='en-US' ? city.pinyin : city.name}}</a>
            </el-col>
          </el-row>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { getQueryString, unionFlag } from '../../utils';
export default {
  props: {
    hotCities: {
      type: Array,
      default: () => [],
    },
    allCities: {
      type: Array,
      default: () => [],
    },
    top: String,
    right: String,
  },
  data() {
    return {
      tabs: [this.TLang('热门', 'my'), 'A-D', 'E-H', 'J-M', 'N-S', 'T-X', 'Y-Z'],
      curTab: this.TLang('热门', 'my'),
      CookiesOne:Cookies.get('df_lang'),
      cityId:
          (Cookies.get("address") &&
              JSON.parse(Cookies.get("address") || "{}").cityId) ||
          145,
    };
  },
  computed: {
    getSelectedCityData() {
      let arr = [];
      const cities = Object.entries(
        this.sortCities(this.hotCities, this.allCities),
      );
      const index = this.tabs.indexOf(this.curTab);
      const hot = cities.slice(0, 1);
      const a2d = cities.slice(1, 5);
      const e2h = cities.slice(5, 9);
      const j2m = cities.slice(9, 13);
      const n2s = cities.slice(13, 18);
      const t2x = cities.slice(18, 21);
      const y2z = cities.slice(21);

      arr = [hot, a2d, e2h, j2m, n2s, t2x, y2z];

      return arr[index];
    },
  },
  methods: {
    sortCities(hotCities, allCities) {
      const obj = {};
      const HOT = this.TLang('热门', 'my');

      obj[HOT] = hotCities;

      allCities.forEach(city => {
        const key = city.first.toLocaleUpperCase();

        if (!obj[key]) {
          obj[key] = [];
        }

        obj[key].push(city);
      });

      return obj;
    },
    async changeCity(cid) {
      const { path, query } = this.$route;
      const { city } = query;
      //一点小优化
      if (cid === Number(city)) {
        return false;
      }
      await this.cacheAddress(cid);
      this.$router.replace({
        path,
        query: {
          ...query,
          // city: cid,
        },
      });

      const { hostname } = window.location;
      this.publicMethod.setCookie(
        'dffl_mall_city',
        cid,
        31536000,
        '/',
        `.${hostname}`,
      );
      // 调取接口
      if (unionFlag()) {
        const union = unionFlag() || window.sessionStorage.getItem('dffl_union') || getQueryString('union');
        const cookie = Cookies.get(`dfflone_union_${union}`);
        try {
          this.apis.newBfdHeaderApi.saveCity({
            token: cookie,
            cityId: cid,
          }).then(res => {
            window.location.reload();
          });
        } catch (error) {
          window.location.reload();
        }
      } else {
        window.location.reload();
      }
    },
    async cacheAddress(cityId) {
      let address = {};
      // 获取默认城市
      return this.apis.headerApi.getDefaultAddress({id: cityId}).then(body => {
        if (body) {
          try {
            address = {
              provinceId: body.district && body.district.id,
              provinceName: body.district && body.district.name,
              cityName: body.city && body.city.name,
              cityId: body.city && body.city.id,
              regionId: body.region && body.region.id,
              regionName: body.region && body.region.name,
              streetId:
                (body.streets && body.streets.length && body.streets[0].id) ||
                null,
              streetName:
                body.streets && body.streets.length && body.streets[0].name,
            };
            Cookies.set('address', address, { expires: 365 });
            console.log('Cookies.set2', address);
            Cookies.set('city', addressInfo.cityId), { expires: 365 };
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header-city {
  position: absolute;
  right: 0;
  z-index: 5;
  width: 500px;
  background-color: #fff;
  border: 1px solid #c9c9c9;
  font-size: 14px;
  box-sizing: border-box;
  &__hd {
    position: relative;
    height: 50px;
    line-height: 50px;
    background-color: #fafafa;
    border-bottom: 1px solid #d2d3d5;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
  }
  &__tab {
    &_active {
      color: #0b49b7;
    }
  }
  &__close {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding-left: 10px;
    padding-right: 10px;
    > img {
      position: relative;
      width: 20px;
      vertical-align: middle;
      transition: all 0.3s ease-in-out;
    }
    &:hover > img {
      transform: rotate(180deg);
    }
  }
  &__bd {
    padding-left: 15px;
    padding-right: 15px;
    line-height: 21px;
    a {
      color: #828282;
      &:hover {
        color: #619ee0;
      }
    }
  }
  &__label {
    float: left;
    width: 40px;
    padding-left: 8px;
  }
  &__conts {
    overflow: hidden;
    text-align: center;
    a {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
    }
    &_active {
      color: #0b49b7 !important;
      &:hover {
        color: #619ee0 !important;
      }
    }
  }
  &__item {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
